var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _rect2, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _rect3, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 494,
    viewBox: "0 0 290 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9656)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M121.019 510.289C54.1821 510.289 3.05176e-05 498.668 3.05176e-05 484.333C3.05176e-05 469.999 54.1821 458.378 121.019 458.378C187.856 458.378 242.038 469.999 242.038 484.333C242.038 498.668 187.856 510.289 121.019 510.289Z",
    fill: "url(#paint0_radial_1_9656)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.774 173.07L243.779 185.035L207.959 197.003L203.955 185.038L239.774 173.07Z",
    fill: "url(#paint1_linear_1_9656)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.288 148.151L264.059 161.809L261.808 170.769C260.227 177.054 253.854 180.865 247.564 179.29C241.274 177.71 237.46 171.343 239.035 165.058L243.288 148.151Z",
    fill: "url(#paint2_linear_1_9656)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.848 177.012C248.363 178.545 247.528 180.22 245.994 180.728L243.791 181.468C242.257 181.983 240.581 181.149 240.072 179.616C239.556 178.083 240.391 176.408 241.925 175.9L244.129 175.16C245.663 174.645 247.339 175.479 247.848 177.012Z",
    fill: "url(#paint3_linear_1_9656)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.846 173.298L243.698 184.808C244.027 185.791 243.497 186.854 242.513 187.182L239.648 188.14C238.665 188.468 237.601 187.938 237.272 186.955L233.42 175.445C233.091 174.462 233.622 173.399 234.605 173.071L237.47 172.113C238.453 171.785 239.517 172.315 239.846 173.298Z",
    fill: "url(#paint4_linear_1_9656)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.872 195.665C220.195 188.416 217.003 179.853 209.753 176.533C204.618 174.183 198.814 175.118 194.68 178.432C192.974 179.799 201.278 183.965 200.312 186.084C196.99 193.333 190.481 199.458 197.736 202.778C204.991 206.098 213.561 202.908 216.884 195.665H216.872Z",
    fill: "url(#paint5_linear_1_9656)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.564 68.6283C290.379 68.8176 290.243 77.9251 289.805 82.1977C289.722 83.0143 289.621 83.6535 289.55 84.0204C289.426 84.6476 289.147 85.6359 288.733 86.8846C287.649 90.1867 285.683 95.3943 283.444 100.951L277.847 94.0273C277.847 94.0273 280.287 88.4232 281.537 84.7423C281.845 83.8606 282.07 83.0913 282.188 82.5291C282.259 82.1859 282.307 81.7184 282.342 81.1621C282.573 77.1262 282.07 68.4922 285.564 68.6283Z",
    fill: "url(#paint6_linear_1_9656)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M282.336 81.1621C283.491 80.7775 285.108 80.7301 286.831 81.0911C287.957 81.3397 288.975 81.7243 289.799 82.1977C289.716 83.0144 289.615 83.6535 289.544 84.0204C289.42 84.6477 289.141 85.636 288.727 86.8846C287.803 86.9793 286.737 86.9142 285.629 86.6834C283.888 86.3047 282.425 85.5768 281.53 84.7424C281.838 83.8606 282.064 83.0913 282.182 82.5291C282.253 82.1859 282.3 81.7184 282.336 81.1621Z",
    fill: "url(#paint7_linear_1_9656)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M277.793 63.1721C282.591 63.2017 282.531 72.8535 282.117 77.5167C282.034 78.4577 281.951 79.1915 281.868 79.5998C281.75 80.2685 281.489 81.3041 281.098 82.6119C280.038 86.2099 278.06 91.9265 275.833 98.0514L269.809 90.3346C269.809 90.3346 272.516 84.3991 273.825 80.517C274.133 79.6235 274.364 78.8423 274.476 78.2683C274.553 77.8659 274.607 77.3274 274.636 76.6764C274.844 72.2736 274.328 63.1484 277.793 63.1662V63.1721Z",
    fill: "url(#paint8_linear_1_9656)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M274.636 76.6823C275.797 76.2208 277.432 76.1142 279.167 76.4397C280.287 76.6587 281.299 77.0374 282.117 77.5168C282.034 78.4577 281.951 79.1915 281.868 79.5998C281.75 80.2685 281.489 81.3041 281.098 82.6119C280.168 82.7362 279.102 82.7125 277.995 82.4936C276.23 82.1563 274.737 81.4106 273.831 80.523C274.139 79.6294 274.37 78.8482 274.482 78.2742C274.559 77.8718 274.613 77.3333 274.642 76.6823H274.636Z",
    fill: "url(#paint9_linear_1_9656)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M268.832 62.9058C273.369 62.9295 273.564 71.5576 273.227 76.4397C273.132 77.7594 273.002 78.8068 272.907 79.3335C272.812 79.8602 272.635 80.6177 272.356 81.5704C271.367 85.0797 269.276 91.1986 266.878 97.7851L260.86 90.0565C260.86 90.0565 263.893 83.3813 265.107 79.5584C265.296 78.9489 265.439 78.4163 265.521 77.9961C265.622 77.4576 265.675 76.6528 265.711 75.7059C265.835 71.1078 265.533 62.894 268.832 62.9058Z",
    fill: "url(#paint10_linear_1_9656)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M265.711 75.7059C266.872 75.2029 268.56 75.0668 270.348 75.4041C271.438 75.6171 272.415 75.9722 273.221 76.4397C273.126 77.7593 272.996 78.8068 272.901 79.3335C272.806 79.8601 272.629 80.6176 272.35 81.5704C271.403 81.7065 270.307 81.671 269.17 81.4579C267.452 81.1206 266.007 80.4223 265.095 79.5583C265.285 78.9488 265.427 78.4162 265.51 77.9961C265.61 77.4575 265.664 76.6527 265.699 75.7059H265.711Z",
    fill: "url(#paint11_linear_1_9656)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250.709 79.5702C251.953 75.8243 255.175 68.6934 259.587 70.2912C262.602 71.3859 259.723 77.2978 258.237 80.8721C257.893 81.7184 257.615 82.4344 257.514 82.9256C257.413 83.4168 257.36 84.0973 257.342 84.8962C257.253 88.3048 257.745 93.7077 257.745 93.7077L249.483 97.5365C249.495 92.2224 249.619 87.2988 249.838 84.1742C249.933 82.9374 250.04 81.9906 250.158 81.4106C250.235 81.0497 250.419 80.3809 250.703 79.5702H250.709Z",
    fill: "url(#paint12_linear_1_9656)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250.709 79.5702C251.68 79.3335 252.829 79.2507 254.055 79.3927C255.761 79.5821 257.253 80.1383 258.236 80.8721C257.893 81.7184 257.614 82.4344 257.514 82.9256C257.413 83.4168 257.36 84.0973 257.342 84.8962C256.276 85.2631 254.896 85.4111 253.409 85.2513C252.018 85.0974 250.774 84.7068 249.838 84.1742C249.933 82.9374 250.039 81.9906 250.158 81.4107C250.235 81.0497 250.418 80.381 250.703 79.5702H250.709Z",
    fill: "url(#paint13_linear_1_9656)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.428 100.584C247.463 100.436 247.505 100.276 247.552 100.134C247.919 98.8089 248.446 97.578 249.116 96.4359C253.054 89.7074 261.719 86.1922 270.414 88.3759C279.126 90.5595 285.102 97.7733 285.38 105.573C285.422 106.893 285.303 108.218 285.001 109.556C284.978 109.692 284.942 109.84 284.907 109.988C282.561 119.32 272.268 124.776 261.921 122.184C251.574 119.586 245.082 109.917 247.428 100.584Z",
    fill: "url(#paint14_linear_1_9656)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M247.552 100.134C247.919 98.8088 248.446 97.5779 249.116 96.4358C254.12 91.5833 261.897 89.4055 269.667 91.3584C277.462 93.3172 283.284 98.9272 285.38 105.573C285.422 106.892 285.303 108.218 285.001 109.555C284.297 101.756 278.161 94.6901 269.383 92.4828C260.618 90.2813 251.858 93.6071 247.552 100.128V100.134Z",
    fill: "url(#paint15_linear_1_9656)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.693 110.615C282.999 103.904 274.08 111.005 264.284 108.544C254.405 106.07 251.87 96.1814 247.203 101.383C241.771 107.437 239.225 116.681 238.064 124.433C236.536 134.682 231.827 162.064 238.698 167.508C239.61 168.23 242.968 169.017 249.726 170.716C256.489 172.414 259.818 173.308 260.961 173.1C263.229 172.686 265.498 170.568 267.689 167.496C268.151 166.857 268.613 166.171 269.057 165.443C274.637 156.489 279.499 142.097 281.886 135.434C283.325 131.416 284.622 126.794 285.185 122.16C285.268 121.391 285.345 120.616 285.392 119.847C285.605 116.681 285.428 113.55 284.693 110.615Z",
    fill: "url(#paint16_linear_1_9656)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263.46 143.547C266.404 131.842 270.118 121.397 285.179 122.154C284.616 126.788 283.319 131.41 281.88 135.428C279.499 142.091 274.631 156.477 269.051 165.437L263.176 163.963C257.573 162.555 260.019 157.229 263.454 143.553L263.46 143.547Z",
    fill: "url(#paint17_linear_1_9656)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M259.776 148.477C260.215 146.826 260.7 144.991 261.204 142.979C263.632 133.327 267.257 118.906 285.392 119.841C285.345 120.61 285.268 121.379 285.185 122.154C270.123 121.397 266.404 131.842 263.466 143.547C260.025 157.229 257.585 162.555 263.188 163.958L269.063 165.431C268.619 166.159 268.157 166.845 267.695 167.485L262.625 166.212C260.635 165.715 259.261 164.78 258.42 163.354C256.643 160.342 257.751 156.116 259.782 148.471L259.776 148.477Z",
    fill: "url(#paint18_linear_1_9656)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.211 195.665H196.391C199.696 195.665 202.397 192.966 202.397 189.664C202.397 186.362 199.696 183.664 196.391 183.664H187.211C183.906 183.664 181.206 186.362 181.206 189.664C181.206 192.966 183.906 195.665 187.211 195.665Z",
    fill: "url(#paint19_linear_1_9656)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M169.828 190.286C169.828 201.76 175.455 211.063 182.39 211.063C189.326 211.063 191.807 201.76 191.807 190.286C191.807 178.811 189.332 169.508 182.39 169.508C175.449 169.508 169.828 178.811 169.828 190.286Z",
    fill: "url(#paint20_linear_1_9656)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193.72 190.291C193.72 208.761 186.346 209.773 192.85 209.773C192.921 209.773 192.992 209.773 193.057 209.761C193.56 209.749 194.046 209.69 194.514 209.577C200.022 208.216 203.262 200.091 203.262 190.291C203.262 180.492 200.093 172.544 194.703 171.053C194.212 170.911 193.702 170.834 193.175 170.81C193.069 170.798 192.956 170.798 192.85 170.798C186.352 170.798 193.72 171.124 193.72 190.291Z",
    fill: "url(#paint21_linear_1_9656)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M193.057 209.761C193.56 209.749 194.046 209.69 194.514 209.578C196.468 205.855 198.997 199.21 198.997 189.664C198.997 180.119 196.646 174.444 194.698 171.053C194.206 170.911 193.697 170.834 193.17 170.81C195.071 173.858 197.831 179.935 197.831 189.664C197.831 199.393 194.976 206.329 193.057 209.761Z",
    fill: "url(#paint22_linear_1_9656)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1811 304.884C62.5398 299.248 62.5397 290.109 68.1811 284.472C73.8224 278.836 82.9688 278.836 88.6101 284.472C94.2514 290.109 94.2514 299.248 88.6101 304.884C82.9688 310.521 73.8224 310.521 68.1811 304.884Z",
    fill: "url(#paint23_linear_1_9656)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1766 352.598L63.077 344.189V334.702C63.077 328.051 68.4727 322.66 75.1298 322.66C81.7869 322.66 87.1825 328.051 87.1825 334.702V352.598H87.1766Z",
    fill: "url(#paint24_linear_1_9656)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1445 323.855C78.1445 325.522 76.7935 326.873 75.1269 326.873C73.4603 326.873 72.1093 325.522 72.1093 323.855V321.476C72.1093 319.81 73.4603 318.458 75.1269 318.458C76.7935 318.458 78.1445 319.81 78.1445 321.476V323.855Z",
    fill: "url(#paint25_linear_1_9656)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0818 287.81H64.1077C63.237 287.81 62.5322 288.514 62.5322 289.384V314.345H87.7156V307.433C87.7156 296.604 78.9144 287.816 68.0818 287.816V287.81Z",
    fill: "url(#paint26_linear_1_9656)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6033 322.482H87.6504C88.8764 322.482 89.8715 321.488 89.8715 320.263V314.487C89.8715 313.262 88.8764 312.268 87.6504 312.268H62.6033C61.3772 312.268 60.3822 313.262 60.3822 314.487V320.263C60.3822 321.488 61.3772 322.482 62.6033 322.482Z",
    fill: "url(#paint27_linear_1_9656)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.549 458.378H44.6217L55.1997 355.154C55.4544 353.178 56.1533 351.29 57.2371 349.627L61.2882 343.39C61.4955 343.159 61.7443 342.982 62.0108 342.857C62.3484 342.68 62.7215 342.603 63.1065 342.603H87.0639C87.4489 342.603 87.822 342.686 88.1596 342.857C88.4261 342.987 88.6749 343.159 88.8822 343.39L92.9333 349.627C94.0172 351.29 94.7161 353.178 94.9708 355.154L105.549 458.378Z",
    fill: "url(#paint28_linear_1_9656)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M89.3147 458.378H60.8619L62.0168 342.851C62.3544 342.674 62.7276 342.597 63.1126 342.597H87.0699C87.4549 342.597 87.8281 342.68 88.1656 342.851L89.3206 458.378H89.3147Z",
    fill: "url(#paint29_linear_1_9656)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M75.0883 345.609C68.9464 345.609 65.5586 349.177 65.5586 361.297C65.5586 373.417 67.7027 409.976 75.0883 409.976C82.4739 409.976 84.618 373.422 84.618 361.297C84.618 349.172 81.2302 345.609 75.0883 345.609Z",
    fill: "url(#paint30_linear_1_9656)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8956 446.027C39.8956 450.217 41.4711 453.608 43.4078 453.608C45.3445 453.608 46.92 450.211 46.92 446.027C46.92 441.844 45.3445 438.447 43.4078 438.447C41.4711 438.447 39.8956 441.844 39.8956 446.027Z",
    fill: "url(#paint31_linear_1_9656)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4019 446.027C43.4019 452.347 41.8797 455.951 44.8174 454.839C46.2033 454.312 47.5004 450.892 47.5004 446.027C47.5004 441.163 46.3336 437.879 44.8174 437.216C42.4957 436.204 43.4019 439.678 43.4019 446.027Z",
    fill: "url(#paint32_linear_1_9656)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.044 446.027C110.044 450.217 108.469 453.608 106.532 453.608C104.595 453.608 103.02 450.211 103.02 446.027C103.02 441.844 104.595 438.447 106.532 438.447C108.469 438.447 110.044 441.844 110.044 446.027Z",
    fill: "url(#paint33_linear_1_9656)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M106.538 446.027C106.538 452.348 108.06 455.951 105.122 454.839C103.736 454.312 102.439 450.892 102.439 446.027C102.439 441.163 103.606 437.879 105.122 437.216C107.444 436.204 106.538 439.678 106.538 446.027Z",
    fill: "url(#paint34_linear_1_9656)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0536 435.589C54.3527 435.589 36.7622 453.164 36.7622 474.847V479.723C36.7622 483.191 39.1609 486.191 42.5428 486.943C49.1111 488.399 60.9092 490.411 76.0536 490.411C91.198 490.411 102.901 488.387 109.541 486.925C112.934 486.18 115.345 483.173 115.345 479.7V474.847C115.345 453.164 97.7544 435.589 76.0536 435.589Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0536 433.695C54.3527 433.695 36.7622 451.271 36.7622 472.953V477.829C36.7622 481.297 39.1609 484.298 42.5428 485.049C49.1111 486.505 60.9092 488.517 76.0536 488.517C91.198 488.517 102.901 486.493 109.541 485.031C112.934 484.286 115.345 481.28 115.345 477.806V472.953C115.345 451.271 97.7544 433.695 76.0536 433.695Z",
    fill: "url(#paint35_linear_1_9656)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M50.2187 447.649C57.2253 440.264 65.5527 436.53 76.0477 436.53C81.5322 436.53 99.8689 439.743 106.858 454.36C113.847 468.977 77.2204 472.717 55.9756 464.716C46.2209 461.047 46.8606 451.188 50.2187 447.649Z",
    fill: "url(#paint36_linear_1_9656)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.3644,
    height: 22.4875,
    transform: "matrix(-1 0 0 1 115.535 466.42)",
    fill: "url(#pattern0_1_9656)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M153.464 304.886C147.823 299.25 147.823 290.111 153.464 284.474C159.105 278.838 168.252 278.838 173.893 284.474C179.534 290.111 179.534 299.25 173.893 304.886C168.252 310.523 159.105 310.523 153.464 304.886Z",
    fill: "url(#paint37_linear_1_9656)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M154.897 352.598L178.996 344.189V334.703C178.996 328.051 173.601 322.66 166.944 322.66C160.286 322.66 154.891 328.051 154.891 334.703V352.598H154.897Z",
    fill: "url(#paint38_linear_1_9656)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M163.929 321.471C163.929 319.804 165.28 318.453 166.947 318.453C168.613 318.453 169.964 319.804 169.964 321.471V323.85C169.964 325.516 168.613 326.868 166.947 326.868C165.28 326.868 163.929 325.516 163.929 323.85V321.471Z",
    fill: "url(#paint39_linear_1_9656)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M154.352 314.34H179.535V289.379C179.535 288.509 178.83 287.804 177.96 287.804H173.986C163.147 287.804 154.352 296.598 154.352 307.422V314.334V314.34Z",
    fill: "url(#paint40_linear_1_9656)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M154.423 312.268H179.47C180.697 312.268 181.691 313.262 181.691 314.488V320.257C181.691 321.483 180.697 322.477 179.47 322.477H154.423C153.196 322.477 152.202 321.483 152.202 320.257V314.488C152.202 313.262 153.196 312.268 154.423 312.268Z",
    fill: "url(#paint41_linear_1_9656)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M197.41 458.378H136.483L147.061 355.154C147.316 353.178 148.015 351.29 149.099 349.627L153.15 343.39C153.357 343.159 153.606 342.982 153.872 342.857C154.21 342.68 154.583 342.603 154.968 342.603H178.925C179.31 342.603 179.683 342.686 180.021 342.857C180.288 342.987 180.536 343.159 180.744 343.39L184.795 349.627C185.879 351.29 186.578 353.178 186.832 355.154L197.41 458.378Z",
    fill: "url(#paint42_linear_1_9656)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M181.176 458.378H152.723L153.878 342.851C154.216 342.674 154.589 342.597 154.974 342.597H178.931C179.316 342.597 179.689 342.68 180.027 342.851L181.182 458.378H181.176Z",
    fill: "url(#paint43_linear_1_9656)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M166.95 345.609C160.808 345.609 157.42 349.177 157.42 361.297C157.42 373.417 159.564 409.976 166.95 409.976C174.335 409.976 176.479 373.422 176.479 361.297C176.479 349.172 173.091 345.609 166.95 345.609Z",
    fill: "url(#paint44_linear_1_9656)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M131.757 446.028C131.757 450.217 133.332 453.608 135.269 453.608C137.206 453.608 138.781 450.211 138.781 446.028C138.781 441.844 137.206 438.447 135.269 438.447C133.332 438.447 131.757 441.844 131.757 446.028Z",
    fill: "url(#paint45_linear_1_9656)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.257 446.028C135.257 452.348 133.735 455.952 136.673 454.839C138.058 454.312 139.355 450.892 139.355 446.028C139.355 441.163 138.189 437.879 136.673 437.216C134.351 436.204 135.257 439.678 135.257 446.028Z",
    fill: "url(#paint46_linear_1_9656)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M201.905 446.028C201.905 450.217 200.33 453.608 198.393 453.608C196.457 453.608 194.881 450.211 194.881 446.028C194.881 441.844 196.457 438.447 198.393 438.447C200.33 438.447 201.905 441.844 201.905 446.028Z",
    fill: "url(#paint47_linear_1_9656)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M198.399 446.028C198.399 452.348 199.921 455.952 196.984 454.839C195.598 454.312 194.301 450.892 194.301 446.028C194.301 441.163 195.468 437.879 196.984 437.216C199.305 436.204 198.399 439.678 198.399 446.028Z",
    fill: "url(#paint48_linear_1_9656)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M167.915 435.589C146.214 435.589 128.623 453.164 128.623 474.847V479.723C128.623 483.191 131.022 486.191 134.404 486.943C140.972 488.399 152.77 490.411 167.915 490.411C183.059 490.411 194.762 488.387 201.402 486.925C204.796 486.18 207.206 483.173 207.206 479.7V474.847C207.206 453.164 189.616 435.589 167.915 435.589Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M167.915 433.695C146.214 433.695 128.623 451.271 128.623 472.953V477.829C128.623 481.297 131.022 484.298 134.404 485.049C140.972 486.505 152.77 488.517 167.915 488.517C183.059 488.517 194.762 486.493 201.402 485.031C204.796 484.286 207.206 481.28 207.206 477.806V472.953C207.206 451.271 189.616 433.695 167.915 433.695Z",
    fill: "url(#paint49_linear_1_9656)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M142.08 447.649C149.087 440.264 157.414 436.53 167.909 436.53C173.393 436.53 191.73 439.743 198.719 454.36C205.708 468.977 169.082 472.717 147.837 464.716C138.082 461.047 138.722 451.188 142.08 447.649Z",
    fill: "url(#paint50_linear_1_9656)"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 78.7722,
    height: 22.4875,
    transform: "matrix(-1 0 0 1 207.336 466.42)",
    fill: "url(#pattern1_1_9656)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M121.037 260.861C121.037 260.861 87.9168 259.482 78.0199 260.861C69.9473 261.985 60.2932 265.506 62.3484 282.946C62.461 283.911 63.2961 284.627 64.2615 284.55C67.8862 284.272 76.8532 284.532 85.601 292.266C97.2451 302.563 101.906 306.15 106.597 308.647C112.378 311.724 121.037 311.351 121.037 311.351V260.855V260.861Z",
    fill: "url(#paint51_linear_1_9656)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.037 260.861C121.037 260.861 154.157 259.482 164.053 260.861C172.15 261.985 181.839 265.53 179.707 283.112C179.601 283.987 178.842 284.638 177.966 284.567C174.448 284.272 165.345 284.425 156.472 292.272C144.828 302.569 140.167 306.155 135.476 308.653C129.696 311.73 121.037 311.357 121.037 311.357V260.861Z",
    fill: "url(#paint52_linear_1_9656)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M121.019 260.867C121.019 260.867 147.849 259.743 160.44 260.53C157.414 264.287 154.18 268.276 151.965 270.915C142.11 282.697 134.404 297.397 133.012 309.718C127.51 311.641 121.019 311.363 121.019 311.363C121.019 311.363 114.528 311.641 109.025 309.718C107.633 297.397 99.928 282.697 90.0726 270.915C87.8635 268.27 84.6297 264.287 81.6031 260.53C94.1889 259.743 121.025 260.867 121.025 260.867H121.019Z",
    fill: "url(#paint53_linear_1_9656)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9652 222.624L6.11465 214.73L29.745 185.291L39.5955 193.185L15.9652 222.624Z",
    fill: "url(#paint54_linear_1_9656)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1967 242.823L8.39234 244.646L4.70841 236.172C2.1261 230.23 4.85648 223.318 10.8029 220.744C16.7493 218.164 23.6611 220.892 26.2434 226.834L33.1908 242.829L33.1967 242.823Z",
    fill: "url(#paint55_linear_1_9656)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0289 224.23C10.4298 224.466 8.92542 223.354 8.68851 221.756L8.345 219.46C8.10809 217.862 9.22156 216.359 10.8207 216.122C12.4198 215.886 13.9242 216.998 14.1611 218.596L14.5046 220.892C14.7415 222.49 13.6281 223.993 12.0289 224.23Z",
    fill: "url(#paint56_linear_1_9656)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7822 222.479L6.30587 214.885C5.49697 214.237 5.36712 213.056 6.01587 212.248L7.90571 209.893C8.55446 209.085 9.73612 208.955 10.545 209.604L20.0213 217.197C20.8302 217.846 20.96 219.026 20.3113 219.834L18.4215 222.189C17.7727 222.997 16.5911 223.127 15.7822 222.479Z",
    fill: "url(#paint57_linear_1_9656)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0022 189.658C28.0022 197.629 34.4698 204.092 42.4477 204.092C50.4256 204.092 45.2433 197.162 45.2433 189.191C45.2433 181.219 50.4256 175.225 42.4477 175.225C34.4698 175.225 28.0022 181.687 28.0022 189.658Z",
    fill: "url(#paint58_linear_1_9656)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4543 195.665H46.2741C42.9693 195.665 40.2685 192.966 40.2685 189.664C40.2685 186.362 42.9693 183.663 46.2741 183.663H55.4543C58.7592 183.663 61.46 186.362 61.46 189.664C61.46 192.966 58.7592 195.665 55.4543 195.665Z",
    fill: "url(#paint59_linear_1_9656)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8374 190.285C72.8374 201.76 67.2109 211.063 60.2754 211.063C53.3398 211.063 50.8582 201.76 50.8582 190.285C50.8582 178.811 53.3339 169.508 60.2754 169.508C67.2168 169.508 72.8374 178.811 72.8374 190.285Z",
    fill: "url(#paint60_linear_1_9656)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9451 190.291C48.9451 208.761 56.3189 209.773 49.8216 209.773C49.7506 209.773 49.6795 209.773 49.6143 209.761C49.1109 209.749 48.6252 209.69 48.1573 209.577C42.6492 208.216 39.4095 200.091 39.4095 190.291C39.4095 180.492 42.5781 172.544 47.9678 171.053C48.4594 170.911 48.9687 170.834 49.4959 170.81C49.6025 170.798 49.715 170.798 49.8216 170.798C56.3189 170.798 48.9451 171.124 48.9451 190.291Z",
    fill: "url(#paint61_linear_1_9656)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2047 331.613C44.272 334.395 38.8231 327.092 36.5666 323.441C36.1342 322.743 35.8262 322.174 35.6545 321.843C35.3702 321.269 34.9912 320.316 34.5529 319.074C33.3979 315.795 31.781 310.469 30.1641 304.699L38.8231 306.782C38.8231 306.782 40.3038 312.712 41.5594 316.393C41.8556 317.281 42.1458 318.032 42.3945 318.541C42.5426 318.855 42.7914 319.257 43.1053 319.719C45.3796 323.056 51.0536 329.595 48.1988 331.619L48.2047 331.613Z",
    fill: "url(#paint62_linear_1_9656)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1114 319.713C42.4302 320.719 41.1746 321.743 39.5874 322.506C38.545 322.997 37.4966 323.311 36.5608 323.435C36.1285 322.737 35.8205 322.169 35.6487 321.837C35.3644 321.263 34.9854 320.311 34.5471 319.068C35.2223 318.435 36.1048 317.831 37.1235 317.34C38.7345 316.576 40.3395 316.263 41.5596 316.381C41.8557 317.269 42.146 318.02 42.3947 318.529C42.5428 318.843 42.7915 319.245 43.1054 319.707L43.1114 319.713Z",
    fill: "url(#paint63_linear_1_9656)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6872 331.205C53.8671 334.105 48.0273 326.412 45.5101 322.465C45.0008 321.672 44.6217 321.032 44.4322 320.66C44.1183 320.056 43.6918 319.08 43.2062 317.807C41.8499 314.31 39.9309 308.57 37.9586 302.362L47.4409 304.812C47.4409 304.812 48.9157 311.162 50.2424 315.038C50.5444 315.937 50.8346 316.695 51.1012 317.216C51.2848 317.582 51.575 318.038 51.9481 318.577C54.4712 322.192 60.4472 329.11 57.6872 331.211V331.205Z",
    fill: "url(#paint64_linear_1_9656)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9477 318.571C51.3081 319.648 50.0762 320.725 48.5066 321.523C47.482 322.032 46.4514 322.352 45.5157 322.464C45.0063 321.671 44.6273 321.032 44.4377 320.659C44.1238 320.056 43.6974 319.079 43.2117 317.807C43.8751 317.138 44.7339 316.511 45.7466 316.008C47.3517 315.197 48.9923 314.884 50.2479 315.032C50.55 315.931 50.8402 316.689 51.1067 317.209C51.2903 317.576 51.5805 318.032 51.9536 318.571H51.9477Z",
    fill: "url(#paint65_linear_1_9656)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9603 325.956C61.3533 328.702 55.934 321.979 53.2214 317.902C52.487 316.801 51.954 315.89 51.7112 315.41C51.4683 314.931 51.1426 314.221 50.7813 313.304C49.425 309.919 47.3461 303.794 45.2317 297.113L54.7199 299.569C54.7199 299.569 56.3901 306.711 57.7582 310.481C57.9833 311.085 58.1906 311.588 58.3801 311.972C58.6289 312.457 59.0731 313.132 59.6239 313.907C62.3306 317.63 67.584 323.956 64.9603 325.956Z",
    fill: "url(#paint66_linear_1_9656)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6239 313.907C59.0139 315.008 57.7524 316.15 56.1295 316.973C55.1404 317.464 54.1454 317.784 53.2215 317.902C52.4871 316.801 51.954 315.89 51.7112 315.41C51.4684 314.931 51.1426 314.221 50.7813 313.304C51.4506 312.623 52.339 311.978 53.3695 311.457C54.9331 310.676 56.5086 310.351 57.7583 310.481C57.9833 311.085 58.1906 311.588 58.3802 311.972C58.6289 312.458 59.0731 313.132 59.6239 313.907Z",
    fill: "url(#paint67_linear_1_9656)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1534 301.711C70.4564 305.433 72.251 313.055 67.7793 314.476C64.7232 315.446 63.3965 309.008 62.3956 305.268C62.1527 304.386 61.9336 303.652 61.7145 303.202C61.4953 302.753 61.1163 302.179 60.6484 301.533C58.6406 298.776 54.9507 294.793 54.9507 294.793L59.1677 286.721C62.3956 290.941 65.3036 294.917 67.039 297.533C67.7201 298.569 68.2117 299.385 68.4663 299.918C68.6263 300.255 68.8869 300.888 69.1593 301.711H69.1534Z",
    fill: "url(#paint68_linear_1_9656)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1534 301.711C68.5255 302.492 67.6668 303.255 66.6066 303.894C65.1378 304.782 63.6156 305.256 62.3896 305.267C62.1468 304.386 61.9276 303.652 61.7085 303.202C61.4893 302.752 61.1103 302.178 60.6424 301.533C61.2643 300.592 62.2712 299.634 63.5445 298.853C64.7409 298.131 65.9669 297.675 67.033 297.527C67.7141 298.563 68.2057 299.379 68.4604 299.912C68.6203 300.249 68.8809 300.882 69.1534 301.705V301.711Z",
    fill: "url(#paint69_linear_1_9656)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6083 209.761C49.1049 209.749 48.6192 209.69 48.1513 209.577C46.1968 205.855 43.6678 199.209 43.6678 189.664C43.6678 180.119 46.0191 174.444 47.9677 171.053C48.4593 170.911 48.9687 170.834 49.4958 170.81C47.5946 173.858 44.8346 179.935 44.8346 189.664C44.8346 199.393 47.6893 206.328 49.6083 209.761Z",
    fill: "url(#paint70_linear_1_9656)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9368 283.052C58.996 283.188 59.0611 283.342 59.1144 283.484C59.6297 284.757 59.9673 286.059 60.1272 287.372C61.1104 295.101 56.3841 303.167 48.1574 306.735C39.9189 310.31 30.7801 308.232 25.8051 302.22C24.97 301.202 24.2533 300.078 23.6729 298.829C23.6077 298.705 23.5485 298.569 23.4834 298.427C19.6514 289.597 24.4784 279.005 34.2686 274.756C44.053 270.513 55.0988 274.223 58.9368 283.052Z",
    fill: "url(#paint71_linear_1_9656)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1146 283.484C59.6298 284.757 59.9674 286.058 60.1273 287.372C59.1205 294.266 54.2816 300.729 46.9315 303.912C39.5577 307.108 31.5206 306.203 25.8052 302.214C24.9701 301.196 24.2534 300.072 23.673 298.823C28.9916 304.575 38.1659 306.439 46.4696 302.841C54.7614 299.243 59.6772 291.278 59.1146 283.478V283.484Z",
    fill: "url(#paint72_linear_1_9656)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3387 228.857C20.7352 226.082 23.8743 224.662 25.0411 224.679C33.8067 224.816 46.7834 249.386 51.8236 258.446C58.9072 271.181 65.3333 290.935 45.1132 299.705L14.3446 228.863L14.3387 228.857Z",
    fill: "url(#paint73_linear_1_9656)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3387 228.857L45.1072 299.705C31.7929 305.475 22.8852 299.586 17.0868 290.911C16.6545 290.272 16.2458 289.615 15.8431 288.952C13.4621 284.934 11.6735 280.484 10.3645 276.424C8.1909 269.69 3.26912 255.322 2.22672 244.824C2.13788 243.977 2.08458 243.149 2.06089 242.362C1.91874 238.592 2.43403 235.527 3.97393 233.816C4.75573 232.958 7.94214 231.639 14.3446 228.863L14.3387 228.857Z",
    fill: "url(#paint74_linear_1_9656)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0126 258.76C24.8219 269.832 28.2452 280.372 15.843 288.946C13.4621 284.928 11.6734 280.478 10.3645 276.419C8.19087 269.684 3.2691 255.316 2.2267 244.818L7.78222 242.409C13.083 240.113 14.392 245.824 20.0126 258.76Z",
    fill: "url(#paint75_linear_1_9656)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9299 252.606C20.5933 254.186 21.3277 255.931 22.1509 257.837C26.1132 266.962 32.0419 280.608 17.087 290.911C16.6546 290.272 16.246 289.615 15.8432 288.952C28.2454 280.378 24.8221 269.838 20.0128 258.766C14.3922 245.824 13.0833 240.113 7.78242 242.415L2.22691 244.824C2.13807 243.977 2.08476 243.149 2.06107 242.362L6.85848 240.279C8.7419 239.462 10.4003 239.367 11.9343 239.983C15.1799 241.291 16.8797 245.315 19.9358 252.611L19.9299 252.606Z",
    fill: "url(#paint76_linear_1_9656)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1806 213.501C60.3228 213.714 60.4709 213.921 60.6248 214.134C68.3955 225.023 85.2515 235.32 101.681 240.421C108.421 242.528 115.096 243.747 121.043 243.764C141.44 243.676 170.491 229.485 181.454 214.128C181.608 213.915 181.75 213.708 181.898 213.495C192.536 197.86 188.727 176.734 181.898 169.017C181.561 168.644 181.176 168.26 180.744 167.875C176.823 164.49 169.662 162.235 159.019 161.448C158.403 161.401 157.787 161.36 157.141 161.324C156.976 161.312 156.816 161.306 156.644 161.306C156.17 161.277 155.69 161.259 155.199 161.241C154.826 161.224 154.334 161.212 153.783 161.194C153.12 161.176 152.368 161.158 151.55 161.147C150.976 161.135 150.366 161.135 149.75 161.135H149.43C139.35 161.17 130.928 161.135 121.031 161.135C111.134 161.135 102.712 161.17 92.6312 161.135H92.3114C91.6954 161.135 91.0913 161.135 90.5109 161.147C89.7409 161.158 89.0302 161.176 88.3965 161.194C87.7983 161.206 87.2712 161.224 86.8684 161.241C86.2051 161.271 85.5595 161.3 84.9258 161.336C72.0498 162.058 63.9297 164.786 60.1747 169.023C53.3458 176.74 49.5375 197.866 60.1747 213.501H60.1806Z",
    fill: "url(#paint77_linear_1_9656)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8805 161.241C88.0236 161.194 90.1143 161.135 92.3235 161.135H149.756C151.965 161.135 154.056 161.194 155.199 161.241C155.661 161.259 152.717 173.609 148.382 180.332C144.479 186.386 140.908 192.73 121.043 192.73C101.178 192.73 97.6066 186.386 93.7035 180.332C89.3681 173.603 86.4245 161.259 86.8864 161.241H86.8805Z",
    fill: "url(#paint78_linear_1_9656)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.259 176.207C115.144 173.751 120.332 173.87 123.82 173.68C126.332 173.538 134.339 172.083 136.542 162.916C136.667 162.401 149.217 162.442 152.226 162.815C154.074 163.046 147.162 182.214 140.203 186.617C135.826 189.386 122.304 193.268 105.549 188.806C103.494 188.262 110.08 178.071 112.259 176.213V176.207Z",
    fill: "url(#paint79_linear_1_9656)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 52.7122,
    height: 19.5286,
    transform: "matrix(-1 0 0 1 147.517 171.716)",
    fill: "url(#pattern2_1_9656)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M101.681 240.427C108.421 242.534 115.096 243.753 121.043 243.77C141.44 243.682 170.491 229.491 181.454 214.134C181.608 213.921 181.75 213.714 181.898 213.501C192.536 197.866 188.727 176.74 181.898 169.023C181.561 168.65 181.176 168.266 180.744 167.881C176.823 164.496 169.662 162.241 159.019 161.454C158.403 161.407 157.787 161.366 157.141 161.33C156.976 161.318 156.816 161.312 156.644 161.312C154.713 168.396 150.626 183.184 142.015 188.901C131.129 196.138 125.301 193.197 120.338 196.375C115.369 199.547 113.645 221.691 113.645 221.691L101.681 240.427Z",
    fill: "url(#paint80_linear_1_9656)"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8805 161.241C86.4186 161.259 89.3622 173.609 93.6976 180.332C97.6007 186.386 101.172 192.73 121.037 192.73C140.902 192.73 144.473 186.386 148.376 180.332C152.712 173.604 155.655 161.259 155.193 161.241C155.857 161.271 156.502 161.301 157.136 161.33C157.148 162.33 156.816 164.407 155.329 169.124C154.423 172.023 152.522 177.462 149.993 181.374L149.703 181.823C145.835 187.836 141.464 194.653 121.037 194.653C100.609 194.653 96.2325 187.842 92.3709 181.823L92.0807 181.374C89.5517 177.462 87.6446 172.023 86.7325 169.124C85.2636 164.425 84.926 162.348 84.932 161.342C85.5657 161.301 86.2113 161.277 86.8746 161.247L86.8805 161.241Z",
    fill: "url(#paint81_linear_1_9656)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6249 214.14C71.5879 229.497 100.639 243.688 121.037 243.776C141.435 243.688 170.485 229.497 181.448 214.14C165.167 209.507 144.076 206.725 121.037 206.725C97.9973 206.725 76.9065 209.512 60.6249 214.14Z",
    fill: "url(#paint82_linear_1_9656)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M154.311 185.001C159.132 176.734 160.346 171.39 161.264 168.053C162.176 164.709 176.266 167.638 179.927 173.852C183.587 180.066 183.533 193.6 182.829 196.943C180.258 209.14 175.828 207.252 160.387 204.66C148.542 202.671 140.523 203.737 138.142 200.624C135.761 197.511 147.251 197.115 154.311 185.001Z",
    fill: "url(#paint83_linear_1_9656)"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8515 260.257C94.432 268.045 95.4684 281.893 121.037 281.893C146.605 281.893 147.322 268.388 148.222 260.246C135.316 260.222 120.048 260.861 120.048 260.861C120.048 260.861 106.277 260.293 93.8515 260.257Z",
    fill: "url(#paint84_linear_1_9656)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9877 237.669C103.245 241.427 112.846 243.747 121.043 243.776C129.24 243.741 138.864 241.415 148.133 237.657C147.482 229.721 145.361 217.211 121.043 217.211C96.724 217.211 94.8702 229.467 93.9877 237.669Z",
    fill: "url(#paint85_linear_1_9656)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9877 237.669C103.245 241.427 112.846 243.747 121.043 243.776C129.24 243.741 138.864 241.415 148.133 237.657C147.482 229.721 145.361 217.211 121.043 217.211C96.724 217.211 94.8702 229.467 93.9877 237.669Z",
    fill: "url(#paint86_linear_1_9656)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M97.263 237.509V261.778C97.263 263.832 97.6599 265.796 98.3824 267.595C98.72 268.465 99.1465 269.294 99.6381 270.081C102.41 274.531 107.355 277.496 112.994 277.496H129.068C134.689 277.496 139.622 274.549 142.406 270.116C142.904 269.335 143.324 268.501 143.673 267.631V267.619C144.402 265.808 144.805 263.849 144.805 261.772V237.503C144.805 235.45 144.408 233.485 143.685 231.686C143.401 230.97 143.063 230.272 142.673 229.609C139.954 224.928 134.872 221.78 129.068 221.78H112.994C107.195 221.78 102.137 224.91 99.4071 229.574C99.0221 230.236 98.6727 230.935 98.3884 231.651V231.663C97.6599 233.473 97.2571 235.432 97.2571 237.509H97.263Z",
    fill: "url(#paint87_linear_1_9656)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1493 244.765V254.517C96.1493 254.89 96.4218 255.203 96.7949 255.251C101.136 255.819 109.712 256.701 121.037 256.701C132.361 256.701 140.89 255.807 145.278 255.239C145.645 255.192 145.924 254.878 145.924 254.505V244.776C145.924 244.404 145.651 244.09 145.278 244.043C140.89 243.474 132.219 242.581 121.037 242.581C109.854 242.581 101.118 243.469 96.7949 244.031C96.4277 244.078 96.1493 244.392 96.1493 244.765Z",
    fill: "url(#paint88_linear_1_9656)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1493 236.941V241.486C96.1493 241.936 96.5343 242.279 96.9785 242.22C101.373 241.652 109.872 240.794 121.037 240.794C132.201 240.794 140.653 241.664 145.095 242.232C145.539 242.291 145.924 241.942 145.924 241.498V236.941C145.924 234.912 145.557 232.965 144.876 231.172C144.799 230.97 144.639 230.811 144.437 230.734C139.835 229.041 131.543 226.668 121.037 226.668C110.53 226.668 101.806 229.106 97.3339 230.811V230.822C96.5758 232.716 96.1493 234.77 96.1493 236.941Z",
    fill: "url(#paint89_linear_1_9656)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6674 226.769C99.2173 227.343 99.7681 228.159 100.467 227.94C105.247 226.443 112.324 224.875 121.031 224.875C129.737 224.875 136.803 226.473 141.63 227.982C142.329 228.201 142.88 227.384 142.429 226.81C139.421 222.952 134.718 220.472 129.447 220.472H112.62C107.361 220.472 102.682 222.934 99.6674 226.763V226.769Z",
    fill: "url(#paint90_linear_1_9656)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M100.805 271.749C100.094 271.531 99.549 272.383 100.029 272.951C103.049 276.531 107.568 278.809 112.626 278.809H129.453C134.487 278.809 138.988 276.555 142.009 272.998C142.489 272.43 141.944 271.578 141.233 271.797C136.459 273.264 129.518 274.75 121.037 274.75C112.555 274.75 105.62 273.229 100.799 271.749H100.805Z",
    fill: "url(#paint91_linear_1_9656)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9785 257.056C96.5343 256.997 96.1493 257.346 96.1493 257.79V262.346C96.1493 264.376 96.5165 266.323 97.1976 268.116C97.2746 268.317 97.4345 268.477 97.6359 268.554C102.238 270.247 110.53 272.62 121.037 272.62C131.543 272.62 140.268 270.182 144.739 268.477V268.465C145.497 266.572 145.924 264.518 145.924 262.346V257.802C145.924 257.352 145.539 257.009 145.095 257.068C140.7 257.636 132.201 258.494 121.037 258.494C109.872 258.494 101.421 257.624 96.9785 257.056Z",
    fill: "url(#paint92_linear_1_9656)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M121.037 171.988C128.458 171.988 134.47 168.165 134.47 160.75V133.552C134.47 132.948 133.978 132.457 133.374 132.457H108.706C108.102 132.457 107.61 132.948 107.61 133.552V160.75C107.61 168.165 113.622 171.988 121.043 171.988H121.037Z",
    fill: "url(#paint93_linear_1_9656)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M107.142 161.448C107.142 161.513 107.16 161.567 107.213 161.608C107.805 162.093 112.212 163.573 121.043 163.573C129.34 163.573 134.185 162.105 134.854 161.608C134.908 161.567 134.937 161.507 134.937 161.442V157.099C134.937 156.933 134.76 156.826 134.617 156.915C133.332 157.726 128.239 158.732 121.043 158.732C113.846 158.732 108.723 157.762 107.468 156.933C107.326 156.838 107.148 156.945 107.148 157.111V161.448H107.142Z",
    fill: "url(#paint94_linear_1_9656)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M108.309 167.39C108.309 167.455 108.327 167.508 108.38 167.549C108.972 168.035 112.212 169.514 121.043 169.514C129.34 169.514 133.018 168.046 133.688 167.549C133.741 167.508 133.771 167.449 133.771 167.384L134.937 163.04C134.937 162.874 134.76 162.768 134.617 162.857C133.332 163.667 128.239 164.673 121.043 164.673C113.846 164.673 108.723 163.703 107.468 162.874C107.326 162.78 107.148 162.886 107.148 163.052L108.315 167.39H108.309Z",
    fill: "url(#paint95_linear_1_9656)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M107.142 155.454C107.142 155.519 107.16 155.572 107.213 155.613C107.805 156.099 112.212 157.578 121.043 157.578C129.34 157.578 134.185 156.11 134.854 155.613C134.908 155.572 134.937 155.513 134.937 155.448V151.104C134.937 150.938 134.76 150.832 134.617 150.921C133.332 151.731 128.239 152.737 121.043 152.737C113.846 152.737 108.723 151.767 107.468 150.938C107.326 150.844 107.148 150.95 107.148 151.116V155.454H107.142Z",
    fill: "url(#paint96_linear_1_9656)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M107.142 143.523C107.142 143.588 107.16 143.642 107.213 143.683C107.805 144.168 112.212 145.648 121.043 145.648C129.34 145.648 134.185 144.18 134.854 143.683C134.908 143.642 134.937 143.582 134.937 143.517V139.174C134.937 139.008 134.76 138.902 134.617 138.99C133.332 139.801 128.239 140.807 121.043 140.807C113.846 140.807 108.723 139.837 107.468 139.008C107.326 138.913 107.148 139.02 107.148 139.186V143.523H107.142Z",
    fill: "url(#paint97_linear_1_9656)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M107.142 149.465C107.142 149.53 107.16 149.583 107.213 149.625C107.805 150.11 112.212 151.589 121.043 151.589C129.34 151.589 134.185 150.122 134.854 149.625C134.908 149.583 134.937 149.524 134.937 149.459V145.115C134.937 144.949 134.76 144.843 134.617 144.932C133.332 145.742 128.239 146.748 121.043 146.748C113.846 146.748 108.723 145.778 107.468 144.949C107.326 144.855 107.148 144.961 107.148 145.127V149.465H107.142Z",
    fill: "url(#paint98_linear_1_9656)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9971 92.7499C37.262 91.5966 36.3116 78.8234 39.8745 64.2201C43.4374 49.6169 50.1642 38.7136 54.8994 39.867C59.6346 41.0203 60.5849 53.7935 57.022 68.3968C53.4592 83 46.7323 93.9033 41.9971 92.7499Z",
    fill: "url(#paint99_linear_1_9656)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2562 103.024C39.8971 101.475 38.62 84.3247 43.4038 64.7172C48.1876 45.1097 57.2207 30.4703 63.5798 32.0192C69.9389 33.5681 71.216 50.7188 66.4322 70.3262C61.6484 89.9337 52.6153 104.573 46.2562 103.024Z",
    fill: "url(#paint100_linear_1_9656)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M202.069 125.557C197.261 124.755 195.373 112.086 197.851 97.2602C200.328 82.4347 206.234 71.0663 211.041 71.8684C215.849 72.6705 217.737 85.3392 215.259 100.165C212.782 114.99 206.876 126.359 202.069 125.557Z",
    fill: "url(#paint101_linear_1_9656)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M194.097 133.326C187.641 132.249 185.105 115.239 188.432 95.3326C191.758 75.4265 199.689 60.1627 206.145 61.2398C212.601 62.3169 215.137 79.3272 211.811 99.2332C208.484 119.139 200.553 134.403 194.097 133.326Z",
    fill: "url(#paint102_linear_1_9656)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0036 93.1398C47.6423 96.4182 47.1745 99.673 47.8437 102.898C49.4547 110.508 56.0704 120.29 65.5586 126.309C79.4414 135.091 102.019 140.943 114.954 143.618C118.928 144.423 123.856 145.311 129.24 146.08C141.417 147.814 155.939 148.95 167.181 147.128C178.274 145.329 188.206 138.937 192.69 132.576C194.573 129.871 195.432 126.699 196.386 123.545C200.49 109.988 205.773 83.9495 204.938 69.8889C204.683 65.4032 205.062 62.1425 203.114 58.1007C202.948 57.7575 202.77 57.3906 202.587 57.0059C199.904 51.5261 195.935 43.7738 191.47 36.4358C191.215 36.0038 190.943 35.5777 190.676 35.1457C190.09 34.1811 189.486 33.2402 188.881 32.3052C188.224 31.2933 187.561 30.2872 186.891 29.3167C186.24 28.3758 185.577 27.4408 184.913 26.559C183.32 24.4168 181.721 22.458 180.151 20.7951C177.462 17.9546 174.175 15.5579 170.687 13.5577C170.024 13.1849 169.366 12.8121 168.685 12.4689C168.484 12.3564 168.276 12.2558 168.081 12.1552C167.459 11.8357 166.831 11.5279 166.192 11.2202C165.635 10.9657 165.084 10.7172 164.551 10.4805C163.816 10.1668 163.082 9.85912 162.36 9.56915C162.33 9.5514 162.283 9.53956 162.253 9.52181C161.892 9.37387 161.542 9.23184 161.175 9.10165C159.996 8.64598 158.818 8.23766 157.686 7.853C156.17 7.34999 154.707 6.91208 153.333 6.52151C152.646 6.3203 151.983 6.13685 151.337 5.98299C149.418 5.4859 147.748 5.10716 146.416 4.82903C145.859 4.71659 145.379 4.61599 144.953 4.53906C144.325 4.4207 143.851 4.34969 143.549 4.30234C143.051 4.17807 142.08 3.94136 140.706 3.66323C139.373 3.39101 137.685 3.07737 135.725 2.7874C135.068 2.67496 134.387 2.58619 133.682 2.49743C132.266 2.31398 130.744 2.14828 129.157 2.01217C127.96 1.92341 126.723 1.83464 125.455 1.7873C125.029 1.76954 124.608 1.75771 124.176 1.75179C123.394 1.73404 122.6 1.72812 121.801 1.72812C121.214 1.73995 120.61 1.74587 120 1.76363C119.289 1.79913 118.597 1.83464 117.898 1.87606C117.679 1.89382 117.453 1.90565 117.222 1.92932C116.458 1.9885 115.712 2.05951 114.954 2.14236C110.956 2.60987 106.994 3.51528 103.399 5.07165C101.089 6.07175 98.6192 7.3855 96.0724 8.89453C95.0419 9.50406 94.0054 10.1491 92.963 10.8237C83.457 16.9308 73.4713 25.2216 67.5901 30.3346C64.2023 33.2875 63.2724 36.4358 61.2705 40.4539C54.9628 53.0469 49.5672 79.0673 47.9977 93.1457L48.0036 93.1398Z",
    fill: "url(#paint103_linear_1_9656)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0842 8.88864C99.1285 21.2153 110.879 27.6361 121.582 29.8316C121.593 29.8316 121.605 29.8316 121.605 29.8316C122.476 33.4178 124.336 36.6903 126.936 39.2527C129.548 41.821 132.894 43.691 136.756 44.484C144.467 46.064 152.03 42.8862 156.454 36.9743C156.454 36.9743 156.466 36.9743 156.478 36.9743C166.612 39.0515 179.097 38.0099 186.897 29.3049C186.246 28.364 185.582 27.429 184.919 26.5472C183.326 24.405 181.727 22.4462 180.157 20.7833C177.468 17.9428 174.181 15.5461 170.693 13.5459C170.029 13.1731 169.372 12.8003 168.691 12.457C168.489 12.3446 168.282 12.244 168.087 12.1434C167.465 11.8238 166.837 11.5161 166.197 11.2084C165.641 10.9539 165.09 10.7054 164.557 10.4687C163.822 10.155 163.094 9.84731 162.365 9.55734C162.336 9.53959 162.288 9.52775 162.259 9.51C161.897 9.36206 161.548 9.22003 161.181 9.08984C160.002 8.63417 158.824 8.22585 157.692 7.84119C156.176 7.33818 154.713 6.90027 153.339 6.5097C152.652 6.30849 151.989 6.12504 151.343 5.97118C149.424 5.47409 147.754 5.09535 146.421 4.81722C145.865 4.70478 145.385 4.60418 144.958 4.52725C144.331 4.40889 143.857 4.33788 143.555 4.29053C143.057 4.16626 142.086 3.92955 140.712 3.65142C139.379 3.3792 137.691 3.07148 135.731 2.77559C135.073 2.66315 134.392 2.57438 133.688 2.48562C132.272 2.30217 130.75 2.13647 129.163 2.00036C127.966 1.91159 126.728 1.82283 125.461 1.77549C125.034 1.75773 124.614 1.7459 124.182 1.73998C123.4 1.72223 122.606 1.71631 121.807 1.71631C121.22 1.72814 120.616 1.73406 120.006 1.75182C119.295 1.78732 118.602 1.82283 117.903 1.86425C117.684 1.88201 117.459 1.89384 117.228 1.91751C116.464 1.97669 115.718 2.0477 114.96 2.13055C110.962 2.59214 107 3.50347 103.411 5.05984C101.101 6.05995 98.631 7.37369 96.0842 8.88272V8.88864Z",
    fill: "url(#paint104_linear_1_9656)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0784 8.88861C99.1227 21.2153 110.873 27.6361 121.576 29.8316C121.588 29.8316 121.599 29.8316 121.599 29.8316C122.47 33.4177 124.33 36.6902 126.93 39.2526C129.542 41.8209 132.888 43.691 136.75 44.4839C144.461 46.064 152.024 42.8861 156.449 36.9743C156.449 36.9743 156.461 36.9743 156.472 36.9743C166.606 39.0514 179.091 38.0099 186.891 29.3049C187.561 30.2754 188.224 31.2755 188.882 32.2933C181.762 39.6846 170.343 42.7855 157.835 40.7676C152.374 46.7623 144.058 49.5377 136.051 47.8985C131.668 46.999 127.67 44.8745 124.484 41.7381C121.919 39.2171 119.994 36.1517 118.833 32.7727C105.596 29.4883 96.0903 21.4106 92.9749 10.806C94.0173 10.1313 95.0538 9.4863 96.0843 8.87677L96.0784 8.88861Z",
    fill: "url(#paint105_linear_1_9656)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1742 6.73456C96.7418 6.98311 96.5227 7.50387 96.6589 7.98321C100.011 19.7773 111.478 25.9614 121.937 28.1036C121.949 28.1036 121.961 28.1036 121.961 28.1036C122.831 31.6898 124.691 34.9623 127.291 37.5247C129.903 40.093 133.249 41.963 137.111 42.756C144.822 44.336 152.386 41.1582 156.81 35.2463C156.81 35.2463 156.822 35.2463 156.834 35.2463C166.707 37.2702 178.813 36.3293 186.643 28.2338C187.004 27.861 187.04 27.2692 186.743 26.8431C186.258 26.1507 185.766 25.4761 185.275 24.8192C183.681 22.677 182.082 20.7182 180.513 19.0553C177.824 16.2148 174.537 13.8181 171.048 11.8179C170.385 11.4451 169.727 11.0723 169.046 10.729C168.845 10.6166 168.638 10.516 168.442 10.4154C167.82 10.0958 167.193 9.78813 166.553 9.4804C165.996 9.22594 165.445 8.97739 164.912 8.74068C164.178 8.42704 163.449 8.11932 162.721 7.82935C162.691 7.81159 162.644 7.79976 162.614 7.782C162.253 7.63406 161.904 7.49203 161.536 7.36184C160.358 6.90617 159.179 6.49785 158.048 6.11319C156.532 5.61019 155.069 5.17227 153.695 4.7817C153.008 4.58049 152.344 4.39704 151.699 4.24318C149.78 3.74609 148.11 3.36735 146.777 3.08922C146.22 2.97678 145.74 2.87618 145.314 2.79925C144.686 2.68089 144.212 2.60988 143.91 2.56254C143.413 2.43826 142.442 2.20155 141.067 1.92342C139.735 1.6512 138.047 1.33756 136.086 1.04759C135.429 0.935154 134.748 0.846387 134.043 0.757621C132.628 0.57417 131.105 0.408473 129.518 0.272364C128.322 0.183598 127.084 0.0948315 125.816 0.0474894C125.39 0.0297361 124.969 0.0179006 124.537 0.0119828C123.755 -0.00577047 122.962 -0.0116882 122.162 -0.0116882C121.576 0.00014729 120.972 0.00606505 120.362 0.0238183C119.651 0.0593249 118.958 0.0948315 118.259 0.136256C118.04 0.154009 117.815 0.165845 117.584 0.189516C116.82 0.248693 116.074 0.319706 115.315 0.402555C111.318 0.86414 107.355 1.77548 103.766 3.33185C101.681 4.23726 99.4603 5.39123 97.1742 6.72272V6.73456Z",
    fill: "url(#paint106_linear_1_9656)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M137.774 39.4953C144.805 40.9333 151.687 38.0454 155.714 32.6603C155.714 32.6603 155.726 32.6603 155.738 32.6603C165.108 34.5776 177.682 33.2698 185.263 24.8311C183.669 22.6888 182.07 20.7301 180.501 19.0672C177.812 16.2266 174.525 13.8299 171.036 11.8297C170.373 11.4569 169.715 11.0841 169.034 10.7409C168.833 10.6284 168.626 10.5278 168.43 10.4272C167.808 10.1077 167.181 9.79994 166.541 9.49222C165.984 9.23776 165.433 8.98921 164.9 8.7525C164.166 8.43886 163.437 8.13114 162.709 7.84117C162.679 7.82341 162.632 7.81158 162.602 7.79382C161.554 12.4511 158.113 17.8067 155.317 22.0852C147.73 33.684 137.78 39.4894 137.78 39.4894L137.774 39.4953Z",
    fill: "url(#paint107_linear_1_9656)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M144.929 69.6522L129.246 146.08C141.423 147.814 155.945 148.95 167.187 147.128C178.28 145.329 188.212 138.937 192.696 132.576C194.579 129.871 195.438 126.699 196.392 123.545C200.496 109.988 205.779 83.9495 204.944 69.8889C204.689 65.4032 205.068 62.1425 203.12 58.1007C202.954 57.7575 202.776 57.3906 202.593 57.0059C199.91 51.5261 195.942 43.7738 191.476 36.4358C191.221 36.0038 190.949 35.5777 190.682 35.1457C185.897 40.1995 176.16 46.4131 160.376 44.987C158.332 44.7917 153.641 46.5788 148.649 55.4259C147.494 57.4557 144.929 69.6581 144.929 69.6581V69.6522Z",
    fill: "url(#paint108_linear_1_9656)"
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2384 42.253C84.8669 38.3591 93.7273 51.7747 133.581 59.9412C173.435 68.1077 186.868 59.2547 192.346 65.8412C197.825 72.4218 191.95 119.859 180.353 129.765C168.756 139.671 132.053 134.623 118.816 131.907C105.579 129.197 69.8469 119.409 63.0891 105.739C56.3312 92.0687 69.61 46.1528 77.2443 42.253H77.2384Z",
    fill: "url(#paint109_linear_1_9656)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M118.46 133.617C118.946 133.718 167.074 143.399 181.484 131.09C193.17 121.107 200.336 72.7116 193.685 64.7227C190.646 61.0714 185.962 61.2844 178.209 61.6336C169.171 62.0419 155.519 62.6514 133.93 58.2309C112.342 53.8103 100.035 47.8748 91.8851 43.9454C84.8904 40.5723 80.6675 38.5425 76.4386 40.6965C67.1814 45.4248 54.7082 92.7373 61.5134 106.508C69.9118 123.492 117.969 133.517 118.454 133.617H118.46ZM187.869 65.2434C189.266 65.5275 190.261 66.0541 191.002 66.9477C195.74 72.6406 189.93 119.273 179.216 128.433C168.324 137.742 132.171 132.86 119.165 130.197C106.153 127.534 71.0016 117.799 64.6524 104.963C58.4099 92.329 71.4339 47.1765 78.0318 43.8093C80.6082 42.4896 83.6762 43.8685 90.3689 47.0936C98.6725 51.0941 111.217 57.142 133.232 61.6513C155.246 66.1607 169.159 65.5334 178.369 65.1191C182.805 64.9179 185.79 64.8173 187.869 65.2434Z",
    fill: "url(#paint110_linear_1_9656)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M77.7453 99.4387C71.6377 90.1873 74.1926 77.7406 83.4517 71.6381C92.7108 65.5357 105.168 68.0883 111.276 77.3397C117.383 86.5911 114.828 99.0378 105.569 105.14C96.31 111.243 83.8529 108.69 77.7453 99.4387Z",
    fill: "url(#paint111_radial_1_9656)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M83.4259 95.6947C79.3878 89.578 81.0769 81.3487 87.1987 77.314C93.3205 73.2793 101.557 74.967 105.595 81.0837C109.633 87.2003 107.944 95.4296 101.822 99.4643C95.7002 103.499 87.464 101.811 83.4259 95.6947Z",
    fill: "url(#paint112_radial_1_9656)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M138.754 111.944C132.646 102.692 135.201 90.2455 144.46 84.143C153.719 78.0405 166.176 80.5932 172.284 89.8446C178.391 99.0959 175.837 111.543 166.577 117.645C157.318 123.748 144.861 121.195 138.754 111.944Z",
    fill: "url(#paint113_radial_1_9656)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M144.434 108.2C140.396 102.083 142.085 93.8536 148.207 89.8189C154.329 85.7841 162.565 87.4719 166.603 93.5885C170.641 99.7052 168.952 107.934 162.83 111.969C156.708 116.004 148.472 114.316 144.434 108.2Z",
    fill: "url(#paint114_radial_1_9656)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M146.048 67.0602C142.72 69.7172 133.267 80.8722 131.082 91.4295C126.154 115.219 132.343 123.468 132.776 128.877C132.876 130.12 161.27 133.96 174.501 127.901C188.55 121.468 192.358 71.1671 188.064 68.4627C184.742 66.3737 175.709 68.2555 165.937 68.2851C156.164 68.3147 147.269 66.0837 146.048 67.0542V67.0602Z",
    fill: "url(#paint115_linear_1_9656)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_9656",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_9656",
    transform: "scale(0.00746269 0.0263158)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_1_9656",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_9656",
    transform: "scale(0.0075188 0.0263158)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_1_9656",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_1_9656",
    transform: "scale(0.0111111 0.0294118)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_9656",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.268 418.253) rotate(180) scale(120.939 25.0009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_9656",
    x1: 225.848,
    y1: 191.02,
    x2: 221.849,
    y2: 179.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_9656",
    x1: 262.469,
    y1: 167.972,
    x2: 239.701,
    y2: 162.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_9656",
    x1: 244.908,
    y1: 181.094,
    x2: 243.045,
    y2: 175.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_9656",
    x1: 241.073,
    y1: 187.657,
    x2: 236.038,
    y2: 172.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_9656",
    x1: 192.036,
    y1: 184.273,
    x2: 216.969,
    y2: 195.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_9656",
    x1: 289.052,
    y1: 85.8676,
    x2: 279.977,
    y2: 83.5862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_9656",
    x1: 289.359,
    y1: 84.6451,
    x2: 281.887,
    y2: 82.7666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_9656",
    x1: 281.33,
    y1: 81.678,
    x2: 271.996,
    y2: 79.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_9656",
    x1: 281.695,
    y1: 80.226,
    x2: 274.176,
    y2: 78.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_9656",
    x1: 272.367,
    y1: 81.4054,
    x2: 263.028,
    y2: 79.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_9656",
    x1: 272.921,
    y1: 79.2014,
    x2: 265.27,
    y2: 77.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_9656",
    x1: 259.838,
    y1: 85.2107,
    x2: 249.792,
    y2: 82.6853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_9656",
    x1: 257.7,
    y1: 83.2952,
    x2: 250.118,
    y2: 81.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_9656",
    x1: 247.582,
    y1: 99.8599,
    x2: 284.683,
    y2: 110.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_9656",
    x1: 286.665,
    y1: 102.774,
    x2: 249.21,
    y2: 93.3579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_9656",
    x1: 277.196,
    y1: 166.309,
    x2: 240.787,
    y2: 102.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_9656",
    x1: 273.632,
    y1: 119.37,
    x2: 271.311,
    y2: 162.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_9656",
    x1: 279.546,
    y1: 144.4,
    x2: 261.833,
    y2: 139.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_9656",
    x1: 191.801,
    y1: 183.735,
    x2: 191.801,
    y2: 195.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_9656",
    x1: 191.801,
    y1: 190.286,
    x2: 169.828,
    y2: 190.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_9656",
    x1: 203.262,
    y1: 190.286,
    x2: 190.167,
    y2: 190.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_9656",
    x1: 196.166,
    y1: 209.394,
    x2: 195.611,
    y2: 170.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_9656",
    x1: 92.8391,
    y1: 294.679,
    x2: 63.9481,
    y2: 294.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_9656",
    x1: 63.0711,
    y1: 337.632,
    x2: 87.1766,
    y2: 337.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_9656",
    x1: 72.1034,
    y1: 322.66,
    x2: 78.1445,
    y2: 322.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_9656",
    x1: 62.5322,
    y1: 301.072,
    x2: 87.7156,
    y2: 301.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_9656",
    x1: 60.3822,
    y1: 317.375,
    x2: 89.8655,
    y2: 317.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_9656",
    x1: 49.5613,
    y1: 409.261,
    x2: 122.753,
    y2: 390.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_9656",
    x1: 102.558,
    y1: 433.944,
    x2: 45.1698,
    y2: 365.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_9656",
    x1: 87.834,
    y1: 409.846,
    x2: 68.478,
    y2: 352.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_9656",
    x1: 46.9182,
    y1: 446.029,
    x2: 39.8956,
    y2: 446.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1B6B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1E8022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#32922A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#31CF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_9656",
    x1: 47.5004,
    y1: 446.039,
    x2: 43.0051,
    y2: 446.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_9656",
    x1: 103.014,
    y1: -0.000100264,
    x2: 110.044,
    y2: -0.000100264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1B6B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1E8022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#32922A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#31CF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#35E229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_9656",
    x1: 102.439,
    y1: 446.039,
    x2: 106.935,
    y2: 446.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_9656",
    x1: 99.3772,
    y1: 468.906,
    x2: 21.7501,
    y2: 449.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_9656",
    x1: 66.2812,
    y1: 468.965,
    x2: 90.0257,
    y2: 440.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_9656",
    x1: 149.233,
    y1: 294.681,
    x2: 178.118,
    y2: 294.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_9656",
    x1: 178.996,
    y1: 337.632,
    x2: 154.897,
    y2: 337.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_9656",
    x1: 169.964,
    y1: 322.66,
    x2: 163.929,
    y2: 322.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_9656",
    x1: 179.535,
    y1: 301.072,
    x2: 154.352,
    y2: 301.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_9656",
    x1: 181.691,
    y1: 317.375,
    x2: 152.202,
    y2: 317.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1_9656",
    x1: 141.423,
    y1: 409.261,
    x2: 214.614,
    y2: 390.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_9656",
    x1: 194.419,
    y1: 433.944,
    x2: 137.031,
    y2: 365.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_9656",
    x1: 179.695,
    y1: 409.846,
    x2: 160.339,
    y2: 352.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_9656",
    x1: 138.779,
    y1: 446.029,
    x2: 131.757,
    y2: 446.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1B6B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1E8022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#32922A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#31CF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1_9656",
    x1: 139.361,
    y1: 446.039,
    x2: 134.866,
    y2: 446.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_9656",
    x1: 194.875,
    y1: 0.0000218062,
    x2: 201.905,
    y2: 0.0000218062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1B6B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1E8022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#32922A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#31CF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#35E229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_9656",
    x1: 194.301,
    y1: 446.039,
    x2: 198.796,
    y2: 446.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_9656",
    x1: 191.238,
    y1: 468.906,
    x2: 113.611,
    y2: 449.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1_9656",
    x1: 158.142,
    y1: -0.0000587596,
    x2: 181.865,
    y2: 440.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1_9656",
    x1: 59.6891,
    y1: 285.615,
    x2: 101.812,
    y2: 285.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1_9656",
    x1: 182.384,
    y1: 285.615,
    x2: 140.268,
    y2: 285.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1_9656",
    x1: 100.692,
    y1: 303.942,
    x2: 126.781,
    y2: 248.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1_9656",
    x1: 17.9059,
    y1: 199.889,
    x2: 27.75,
    y2: 207.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1_9656",
    x1: 5.92629,
    y1: 238.788,
    x2: 27.4575,
    y2: 229.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1_9656",
    x1: 8.44133,
    y1: 220.65,
    x2: 14.2587,
    y2: 219.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1_9656",
    x1: 6.93783,
    y1: 210.938,
    x2: 19.3353,
    y2: 220.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1_9656",
    x1: 46.8957,
    y1: 189.658,
    x2: 28.0022,
    y2: 189.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1_9656",
    x1: 50.8583,
    y1: 183.734,
    x2: 50.8583,
    y2: 195.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1_9656",
    x1: 50.8582,
    y1: -0.000165037,
    x2: 72.8374,
    y2: -0.000165037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1_9656",
    x1: 39.4036,
    y1: 190.285,
    x2: 52.4928,
    y2: 190.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1_9656",
    x1: 34.9331,
    y1: 320.077,
    x2: 43.5152,
    y2: 316.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1_9656",
    x1: 35.4355,
    y1: 321.234,
    x2: 42.5021,
    y2: 318.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1_9656",
    x1: 43.6108,
    y1: 318.695,
    x2: 52.4373,
    y2: 314.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1_9656",
    x1: 44.2046,
    y1: 320.063,
    x2: 51.3147,
    y2: 316.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1_9656",
    x1: 50.8824,
    y1: 313.451,
    x2: 59.7144,
    y2: 309.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1_9656",
    x1: 51.7879,
    y1: 315.536,
    x2: 59.0283,
    y2: 312.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1_9656",
    x1: 58.4924,
    y1: 302.804,
    x2: 67.9924,
    y2: 298.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1_9656",
    x1: 61.3561,
    y1: 303.02,
    x2: 68.5259,
    y2: 299.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1_9656",
    x1: 46.4989,
    y1: 209.394,
    x2: 47.0547,
    y2: 170.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1_9656",
    x1: 59.2709,
    y1: 283.726,
    x2: 23.2944,
    y2: 297.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1_9656",
    x1: 26.5114,
    y1: 305.221,
    x2: 61.9369,
    y2: 289.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1_9656",
    x1: 60.8845,
    y1: 288.11,
    x2: 6.42752,
    y2: 229.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1_9656",
    x1: 50.5196,
    y1: 297.707,
    x2: -3.93977,
    y2: 238.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1_9656",
    x1: 26.7229,
    y1: 284.125,
    x2: 2.17098,
    y2: 248.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1_9656",
    x1: 6.7554,
    y1: 267.882,
    x2: 23.5067,
    y2: 260.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1_9656",
    x1: 188.514,
    y1: 202.453,
    x2: 53.559,
    y2: 202.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1_9656",
    x1: 121.037,
    y1: 192.73,
    x2: 121.037,
    y2: 161.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1_9656",
    x1: 152.528,
    y1: 176.681,
    x2: 105.158,
    y2: 176.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1_9656",
    x1: 161.453,
    y1: 232.166,
    x2: 127.187,
    y2: 184.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1_9656",
    x1: 156.242,
    y1: 177.947,
    x2: 85.2281,
    y2: 177.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1_9656",
    x1: 114.901,
    y1: 245.599,
    x2: 122.824,
    y2: 204.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1_9656",
    x1: 171.439,
    y1: 204.559,
    x2: 148.112,
    y2: 171.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1_9656",
    x1: 148.524,
    y1: 271.069,
    x2: 93.7508,
    y2: 271.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1_9656",
    x1: 94.0173,
    y1: 230.378,
    x2: 148.163,
    y2: 230.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1_9656",
    x1: 148.352,
    y1: 230.491,
    x2: 93.3007,
    y2: 230.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1_9656",
    x1: 144.811,
    y1: 249.641,
    x2: 97.2631,
    y2: 249.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1_9656",
    x1: 145.924,
    y1: 249.641,
    x2: 96.1493,
    y2: 249.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1_9656",
    x1: 145.924,
    y1: 234.45,
    x2: 96.1493,
    y2: 234.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1_9656",
    x1: 142.601,
    y1: 224.254,
    x2: 99.5075,
    y2: 224.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1_9656",
    x1: 142.193,
    y1: 275.259,
    x2: 99.8451,
    y2: 275.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1_9656",
    x1: 145.924,
    y1: 264.832,
    x2: 96.1493,
    y2: 264.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1_9656",
    x1: 134.47,
    y1: 152.216,
    x2: 107.604,
    y2: 152.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1_9656",
    x1: 134.931,
    y1: 160.223,
    x2: 107.142,
    y2: 160.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1_9656",
    x1: 134.931,
    y1: 166.165,
    x2: 107.142,
    y2: 166.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1_9656",
    x1: 134.931,
    y1: 154.235,
    x2: 107.142,
    y2: 154.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1_9656",
    x1: 134.931,
    y1: 142.304,
    x2: 107.142,
    y2: 142.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1_9656",
    x1: 134.931,
    y1: 148.246,
    x2: 107.142,
    y2: 148.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1_9656",
    x1: 57.0149,
    y1: 68.4011,
    x2: 39.8747,
    y2: 64.2193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1_9656",
    x1: 66.425,
    y1: 70.3306,
    x2: 43.4046,
    y2: 64.7141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1B6B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1E8022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#32922A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#31CF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1_9656",
    x1: 197.815,
    y1: 97.2602,
    x2: 215.217,
    y2: 100.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1_9656",
    x1: 188.397,
    y1: 95.3268,
    x2: 211.769,
    y2: 99.2328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#146440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1E8232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#26CE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1_9656",
    x1: 204.199,
    y1: 89.284,
    x2: 54.3273,
    y2: 58.5212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1_9656",
    x1: 185.985,
    y1: 33.7506,
    x2: 94.8188,
    y2: 15.0378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1_9656",
    x1: 186.713,
    y1: 42.8705,
    x2: 90.4472,
    y2: 23.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1_9656",
    x1: 186.042,
    y1: 31.9682,
    x2: 95.4276,
    y2: 13.3686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1_9656",
    x1: 217.037,
    y1: 64.0599,
    x2: 137.69,
    y2: 15.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1_9656",
    x1: 190.087,
    y1: 109.082,
    x2: 110.734,
    y2: 60.3326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1_9656",
    x1: 191.07,
    y1: 105.411,
    x2: 62.8268,
    y2: 79.0879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1_9656",
    x1: 192.788,
    y1: 105.763,
    x2: 61.1152,
    y2: 78.7359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_1_9656",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.6744 -4.03162 -4.03501 19.658 94.5061 88.3899)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0CB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0A9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#032B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_1_9656",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.008 -2.66556 -2.66779 12.9971 94.506 88.3899)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0A9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#033300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_1_9656",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.6744 -4.03163 -4.035 19.658 155.515 100.889)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0CB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0A9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#076900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#032B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_1_9656",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.008 -2.66556 -2.66779 12.9971 155.515 100.889)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0A9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#033300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1_9656",
    x1: 186.791,
    y1: 104.081,
    x2: 130.835,
    y2: 92.5955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 510.289,
    fill: "white",
    transform: "matrix(-1 0 0 1 290 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_9656",
    width: 134,
    height: 38,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_9656",
    width: 133,
    height: 38,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_1_9656",
    width: 90,
    height: 34,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/Bot.0ee6a4f7237db33159b553d17a2588e6.svg";
export { ForwardRef as ReactComponent };